export enum DifficultyTypeEnum {
  LIX = 'LIX',
  LET = 'LET',
  LUS = 'LUS',
  LEVEL = 'LEVEL',
}
